import _ from 'lodash'

import { AllItemsServer } from "../../../ui-formly/types/selectAsync/AllItemsServer"

import fieldHelpers from '../../../ui-formly/fieldHelpers/index'
import { defaultModelOptions } from '../../../utils/modelOptions'

function formly(server, $q, authService) {
  const manufacturerServer = new AllItemsServer(server, {
    queryMethod: 'partManufacturerQuery',
    saveMethod: 'partManufacturerSave'
  }, $q)

  const partkeywordServer = new AllItemsServer(server, {
    queryMethod: 'keywordQuery',
    saveMethod: 'keywordSave'
  }, $q)

  const partTypeServer = new AllItemsServer(server, {
    queryMethod: 'partTypeQuery',
    saveMethod: 'partTypeSave'
  }, $q)

  var fields = [
    fieldHelpers.columnLayout([
      _.assign(fieldHelpers.simpleStringField({ key: 'PartNumber', label: 'Part Number', required: true }), {
        asyncValidators: {
          unique: {
            expression: function checkPartNumberUniqueness(modelValue, viewValue, scope) {
              var value = modelValue || viewValue
              var model = scope.model

              return server.partQuery({
                PartNumber: value,
                Take: 2
              })
                .then(function (result) {
                  if (_.find(result.Results, function (part) {
                    return part.Id !== model.Id
                  })) {
                    return $q.reject('Part Number is not unique')
                  }
                  else {
                    return true
                  }
                })
                .catch(function () {
                  return $q.reject('Something happened')
                })
            }
          }
        },
        validation: {
          messages: {
            unique: function () {
              return 'Part Number is not unique'
            }
          }
        },
        modelOptions: defaultModelOptions
      }),
      {
        key: 'Status',
        type: 'select',
        templateOptions: {
          label: 'Status',
          options: [
            {
              label: 'Active',
              value: 'Active'
            },
            {
              label: 'Obsolete',
              value: 'Obsolete'
            }
          ],
          labelProp: 'label',
          valueProp: 'value'
        }
      },
      fieldHelpers.simpleNumberField({ key: 'Par', label: 'Par', min: 0 }),
      {
        key: 'PartManufacturerId',
        type: 'selectAsync',
        templateOptions: {
          label: 'Manufacturer',
          required: true,
          showAddButton: authService.hasPermission('partEdit'),
          query: [function () {
            return function (search) {
              return manufacturerServer.search(search)
            }
          }],
          getDefaultItem: function (model) {
            const manufacturer = model.PartManufacturer
            if (!manufacturer) {
              return {}
            }
            return {
              Id: manufacturer.Id,
              Name: manufacturer.Name
            }
          },
          saveNewItem: function saveVendor() {
            return function (name) {
              return manufacturerServer.add(name)
            }
          },
          updateNameProp: '.ManufacturerName'
        }
      },
      {
        key: 'PartKeywordId',
        type: 'selectAsync',
        templateOptions: {
          label: 'Keyword',
          showAddButton: authService.hasPermission('partEdit'),
          query: [function () {
            return function (search) {
              return partkeywordServer.search(search)
            }
          }],
          getDefaultItem: function (model) {
            const partKeyword = model.PartKeyword

            if (!partKeyword) {
              return {}
            }

            return {
              Id: partKeyword.Id,
              Name: partKeyword.Name
            }
          },
          saveNewItem: function savePartKeyword() {
            return function (name) {
              return partkeywordServer.add(name)
            }
          },
          updateNameProp: '.PartKeywordName',
        },
      },
      fieldHelpers.simpleStringField({ key: 'CabinetType', label: 'Cabinet Type', required: false }),
      fieldHelpers.simpleCurrencyField({ key: 'UnitPrice', label: 'Unit Price', min: 0 }),
      {
        key: 'TrackedItem',
        name: 'TrackedItem',
        type: 'checkbox',
        templateOptions: {
          label: 'Tracked?',
          defaultIfNull: false
        }
      },
      {
        key: 'PartTypeId',
        type: 'selectAsync',
        templateOptions: {
          label: 'Type',
          required: true,
          showAddButton: authService.hasPermission('partEdit'),
          query: [function () {
            return function (search) {
              return partTypeServer.search(search)
            }
          }],
          getDefaultItem: function (model) {
            const partType = model.PartType
            if (!partType) {
              return {}
            }
            return {
              Id: partType.Id,
              Name: partType.Name
            }
          },
          saveNewItem: function savePartType() {
            return function (name) {
              return partTypeServer.add(name)
            }
          },
          updateNameProp: '.PartTypeName'
        }
      }
    ], 3),
    fieldHelpers.columnLayout([
      fieldHelpers.textAreaField({ key: 'PartDescription', label: 'Description', required: true })
    ], 1),
    {
      key: 'Files',
      name: 'Files',
      type: 'fileUpload',
      templateOptions: {
        label: 'Files'
      }
    },
    {
      key: 'ImageFiles',
      name: 'ImageFiles',
      type: 'fileUpload',
      templateOptions: {
        label: 'Image Files'
      }
    }
  ]

  let formlyFields = _.flatten(fields)
  return formlyFields
}

export default formly